(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["whp-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('whp-delivery')) {
    customElements.define(
      'whp-delivery',
      class WhpDelivery extends HTMLElement {
        connectedCallback() {
          const n = (key, fallback) => {
            const value = parseInt(this.dataset[key], 10);
            return Number.isFinite(value) && value >= 0 ? value : fallback;
          };
          const pmin = n('pmin', 4);
          const pmax = Math.max(pmin, n('pmax', 10));
          const tmin = n('tmin', 5);
          const tmax = Math.max(tmin, n('tmax', 10));

          const addBusinessDays = (start, days) => {
            const date = new Date(start);
            let added = 0;
            while (added < days) {
              date.setDate(date.getDate() + 1);
              const day = date.getDay();
              if (day !== 0 && day !== 6) added += 1;
            }
            return date;
          };
          const locale = document.documentElement.lang || undefined;
          const fmt = (date) => date.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
          const range = (a, b) => (fmt(a) === fmt(b) ? fmt(a) : fmt(a) + ' – ' + fmt(b));

          const today = new Date();
          const shipFrom = addBusinessDays(today, pmin);
          const shipTo = addBusinessDays(today, pmax);
          const arriveFrom = addBusinessDays(today, pmin + tmin);
          const arriveTo = addBusinessDays(today, pmax + tmax);

          const shipped = this.querySelector('[data-slot="shipped"]');
          const delivered = this.querySelector('[data-slot="delivered"]');
          if (shipped) shipped.textContent = range(shipFrom, shipTo);
          if (delivered) delivered.textContent = range(arriveFrom, arriveTo);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
